import { AUDIO_RATE_VALUES } from '@modules/feedback/components/AudioType/AudioFeedbackPlayer/constants';
import { trackAudioFeedbackEvents } from '@modules/feedback/components/AudioType/utils';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useMount } from 'react-use';
import { UUID } from 'v2/core/entities/uuid';

interface AudioRateMenuProps {
  value: number;
  onChange: (rate: number) => void;
  isDisabled?: boolean;
  feedbackID: UUID;
}

const AudioRateMenu = ({
  value,
  onChange,
  isDisabled,
  feedbackID,
}: AudioRateMenuProps) => {
  useMount(() => {
    onChange(value);
  });

  const handleChange = (event: SelectChangeEvent) => {
    onChange(parseFloat(event.target.value));
    trackAudioFeedbackEvents({
      eventName: 'Audio Feedback - Player: Playback Speed Changed',
      feedbackID,
    });
  };

  return (
    <Select
      value={value.toString()}
      size="small"
      onChange={handleChange}
      disabled={isDisabled}
    >
      {AUDIO_RATE_VALUES.map((value) => (
        <MenuItem key={value} value={value}>
          {value}x
        </MenuItem>
      ))}
    </Select>
  );
};

export default AudioRateMenu;
